import React, { useState } from 'react';
import firebase from 'firebase';
import { useHistory } from 'react-router-dom';
import RecommendedCities from './../../RecommendedCities';

const Home = () => {

    const [signedOut, setSignedOut] = useState(false);

    const history = useHistory();

    const onClickSignOut = () => {
        firebase.auth().signOut();
        setSignedOut(true);
    }

    if (signedOut) {
        history.go(0);
    }

    return (
        <div>
            <RecommendedCities />
            <center>
                <p>© Elizabeth Lin, Ginsu Eddy, Arjun Aggarwal</p>
                <button className="button" onClick={() => onClickSignOut()}>Sign Out</button>
            </center>
        </div>
    )
};

export default Home;